import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DateAdapter } from '@angular/material/core';
import { ApiService } from 'src/app/Services/api.service';
import { CommonServices } from 'src/app/Services/common.service';
import { ExcelExportService } from 'src/app/Services/excel.service';
import { LoaderService } from "src/app/Services/loader.service";

@Component({
  selector: 'app-geo-reports',
  templateUrl: './geo-reports.component.html',
  styleUrls: ['./geo-reports.component.css']
})
export class GeoReportsComponent implements OnInit {


  constructor(
    private dateAdapter: DateAdapter<Date>,
    public api: ApiService,
    public com: CommonServices,
    private loader: LoaderService,
    public excel: ExcelExportService
  ) {
    this.dateAdapter.setLocale('en-GB'); //dd/MM/yyyy
  }

  ngOnInit(): void {
    this.filterFormsLoad();
    this.geoEntryExitAPI(({
      date: new Date(new Date(this.filterFormGrp.value.tripDate).setHours(0, 0, 0, 0)).getTime()
    }))
  }

  public filterFormGrp: FormGroup;
  public tableHeaders: any = ['#', 'Reg no', 'Geo point name', 'Entry time', 'Exit time', 'Duration']
  public tableData: any = [];
  public matFormSize: string = '13px';
  public noDataFoundEnable: boolean = false;

  // Excel Variabels
  public excelData: any = [];

  filterFormsLoad() {
    this.filterFormGrp = new FormGroup({
      tripDate: new FormControl(new Date),
    })
  }

  firstLetterCapitalize(val:any){
      let branch = String(val).charAt(0).toUpperCase()+ String(val).slice(1)
      return branch
  }

  onSubmit() {
    let obj = {}
    if (obj['date'] != '') obj['date'] = new Date(new Date(this.filterFormGrp.value.tripDate).setHours(0, 0, 0, 0)).getTime()
    if (this.filterFormGrp.valid) {
      this.geoEntryExitAPI(obj)
    }
  }

  geoEntryExitAPI(obj) {
    this.api.getGeoEntryExitReports(obj).then((res: any) => {
      if (res && res['status'] && res['status'] == 'success') {
        if (res && res['data'] && res['data'].length > 0) {
          this.tableData = res['data']
          if(this.tableData.length > 0){
            this.loader.hide()
          }else{
            this.loader.show()
          }
          if (this.tableData.length <= 0) {
            this.noDataFoundEnable = true
          }
          for (let i = 0; i < this.tableData.length; i++) {
            let entry = this.tableData[i]['entry'];
            let exit = this.tableData[i]['exit'];
          }
        } else {
          this.tableData = [];
          this.noDataFoundEnable = true;
        }
      } else {
        this.tableData = [];
        this.noDataFoundEnable = true;
      }
    }).catch((err) => {
      console.log(err);
    })
  }

  async exportToExcel() {
    this.excelData = {};
    let data = [];
    for (let i = 0; i < this.tableData.length; i++) {
      let item = this.tableData[i];
      try {
        let res = {
          value: [
            i + 1,
            item.regNo ? String(item.regNo).toUpperCase() : '---',
            item.branchName ? this.com.convertTitleCase(item.branchName) : '---',
            item.entry ? this.com.timestampToDate(item.entry, 'H:M:S') : '---',
            item.exit ? this.com.timestampToDate(item.exit, 'H:M:S') : '---',
            item.duration ? item.duration : '---',
          ],
          border: { right: { style: 'thin' }, bottom: { style: 'thin' } },
        }
        data.push(res);
      } catch (err) {
        console.log(err);
      }
    }
    if (data.length > 0) {
      let rowCount = 2;
      let endCell = 'F';
      let customizedData = [];
      let titleRow = {
        value: ['Geo Entry Exit Report'],
        font: {
          name: 'Corbel', family: 4, size: 16, bold: true,
          color: { argb: 'FFFFFFFF' },
        },
        mergeCells: `A${(rowCount - 1) + ''}:${endCell + rowCount + ''}`,
        alignment: {
          cell: `A${(rowCount - 1) + ''}`, value: { vertical: 'middle', horizontal: 'center' },
        },
        fill: {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: '966462AF' },
          bgColor: { argb: 'FFF' }
        },
      }
      customizedData.push(titleRow);

      rowCount = rowCount + 2;

      let subtitleRow = {
        value: [
          "Trip Date          : " + this.com.timestampToDate(new Date(this.filterFormGrp.value.tripDate).getTime(), 'DMY') + "\n"
        ],
        font: { name: 'Corbel', family: 4, size: 12, },
        mergeCells: `A${(rowCount - 1) + ''}:${endCell + rowCount + ''}`,
      }

      customizedData.push(subtitleRow);

      rowCount = rowCount + 1;
      let headerRow =
      {
        value: ['S No', 'Reg no', 'Geo point name', 'Entry time', 'Exit time', 'Duration'],
        font: { bold: true },
        border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } },
      }
      customizedData.push(headerRow);

      customizedData.push(...data);
      let excelSheetName = 'Geo Entry Exit Report';
      if (this.excelData[excelSheetName] == undefined) { this.excelData[excelSheetName] = {}; }

      this.excelData[excelSheetName] = {
        customizedData: customizedData,
        data: {
          columWith: [{ colNo: 2, width: 25 }, { colNo: 3, width: 25 }, { colNo: 4, width: 25 }, { colNo: 5, width: 20 }, { colNo: 6, width: 20 }, { colNo: 7, width: 25 }, { colNo: 8, width: 15 }, { colNo: 9, width: 50 }]
        }
      };
      this.downloadExlReport();
    }
  }
  downloadExlReport() {
    this.excel.generateExcel(this.excelData, 'Geo Entry Exit Report_' + " "+this.com.timestampToDate(new Date().getTime(), 'DMY') + ' '+ '.xlsx');
  }

}
